import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';
import { GetCluedoPista } from '../dao/GetCluedoPista';

const CastronegroCharacters = () => {
    const navigate = useNavigate();
    const [character, setCharacter] = useState<any>(null);
    const [scanning, setScanning] = useState(true);
    const [error, setError] = useState("");

    /*useEffect(() => {
        let scanner: Html5QrcodeScanner | null = null;
        let timer: NodeJS.Timeout;

        if (scanning) {
            // Delay initialization slightly to prevent race conditions in Strict Mode
            timer = setTimeout(() => {
                const element = document.getElementById("reader-castronegro");
                if (element) {
                    element.innerHTML = "";

                    scanner = new Html5QrcodeScanner(
                        "reader-castronegro",
                        {
                            fps: 10,
                            qrbox: { width: 250, height: 250 },
                            supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
                        },
                        false
                    );

                    scanner.render(async (decodedText) => {
                        console.log(`Code matched = ${decodedText}`);
                        if (scanner) {
                            try {
                                await scanner.clear();
                            } catch (e) {
                                console.error("Failed to clear scanner", e);
                            }
                        }

                        // VALIDATION
                        if (decodedText.startsWith("PER") || decodedText.startsWith("PIS")) {
                            setScanning(false);
                            setError("");
                            // Process character data
                            const data = await GetCluedoPista(decodedText);
                            if (data) {
                                setCharacter(data);
                            } else {
                                setError("No se ha encontrado ninguna información de personaje.");
                            }
                        } else {
                            setScanning(false);
                            setError("CÓDIGO NO VÁLIDO: Solo se aceptan códigos de jugador (PERXXX) o pistas (PISXXX).");
                            setCharacter(null);
                        }

                    }, (errorMessage) => {
                        // parse error, ignore it.
                    });
                }
            }, 100);
        }

        return () => {
            clearTimeout(timer);
            if (scanner) {
                try {
                    scanner.clear();
                } catch (e) {
                    // ignore
                }
            }
        };
    }, [scanning]);
*/


    const isWolf = character && (character.qr_code === 'PER100' || character.qr_code === 'PER101' || character.qr_code === 'PER102');
    const isPista = character && character.qr_code.startsWith('PIS');
    const isDead = character && character.titol && character.titol.startsWith('X');

    // Mostramos el título sin la 'X' si está muerto
    const displayTitle = isDead ? character.titol.substring(1).trim() : character?.titol;

    const bgColor = isWolf ? '#121212' : '#f4e4bc'; // Oscuro para lobos, pergamino para inocentes
    const textColor = isWolf ? '#e0e0e0' : '#2c3e50';
    const borderColor = isWolf ? '#8b0000' : '#8b4513'; // Rojo sangre para lobos, marrón para inocentes

    return (
        <div style={{
            backgroundColor: bgColor,
            backgroundImage: isWolf ? 'none' : 'url("https://www.transparenttextures.com/patterns/aged-paper.png")',
            color: textColor,
            minHeight: '100vh',
            fontFamily: '"Georgia", "Times New Roman", serif',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px',
            boxSizing: 'border-box',
            transition: 'background-color 0.5s ease'
        }}>
            <div style={{
                borderBottom: `4px solid ${borderColor}`,
                width: '100%',
                textAlign: 'center',
                marginBottom: '20px',
                paddingBottom: '15px'
            }}>
                <h1 style={{ margin: 0, color: borderColor, fontSize: '3rem', fontStyle: 'italic', lineHeight: '1', textShadow: isWolf ? '0 0 10px rgba(139,0,0,0.8)' : 'none' }}>
                    BeiroLobos de Castronegro
                </h1>
                <small style={{ color: isWolf ? '#ff4c4c' : '#5d4037', fontSize: '1.2rem', marginTop: '5px', display: 'block', fontWeight: 'bold' }}>
                    {isWolf ? "La noche cae..." : "Pueblo de Inocentes"}
                </small>
            </div>

            {scanning ? (
                <div style={{ width: '100%', maxWidth: '600px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div id="reader-castronegro" style={{ border: `6px double ${borderColor}`, borderRadius: '8px', overflow: 'hidden', backgroundColor: isWolf ? '#222' : '#fff8dc', boxShadow: '0 5px 15px rgba(0,0,0,0.2)' }}></div>
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                        <p className="blink" style={{ color: borderColor, fontWeight: 'bold', fontSize: '1.5rem' }}>ESCANEA TU FICHA DE JUGADOR...</p>
                    </div>
                </div>
            ) : (
                <div style={{
                    width: '100%',
                    maxWidth: '800px',
                    border: `2px solid ${borderColor}`,
                    padding: '25px',
                    backgroundColor: isWolf ? '#1a1a1a' : '#fffdf0',
                    boxShadow: isWolf ? '0 0 25px rgba(139,0,0,0.4)' : '10px 10px 20px rgba(0,0,0,0.2)',
                    position: 'relative',
                    marginBottom: '40px',
                    borderRadius: '8px',
                    overflow: 'hidden'
                }}>
                    {character ? (
                        <>
                            {isDead && (
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    pointerEvents: 'none',
                                    zIndex: 10,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backdropFilter: 'grayscale(100%) blur(2px)'
                                }}>
                                    <h1 style={{
                                        color: '#ff3333',
                                        fontSize: '6rem',
                                        transform: 'rotate(-15deg)',
                                        border: '8px solid #ff3333',
                                        padding: '20px',
                                        textTransform: 'uppercase',
                                        textShadow: '4px 4px 10px rgba(0,0,0,0.8)',
                                        backgroundColor: 'rgba(0,0,0,0.4)'
                                    }}>
                                        FANTASMA
                                    </h1>
                                </div>
                            )}

                            <div style={{ position: 'relative', zIndex: 1 }}>
                                <div style={{ borderBottom: `3px double ${borderColor}`, paddingBottom: '20px', marginBottom: '25px', textAlign: 'center' }}>
                                    <h2 style={{ margin: 0, fontSize: '2.5rem', color: borderColor, textTransform: 'uppercase', letterSpacing: '2px' }}>
                                        {displayTitle}
                                    </h2>
                                    <span style={{ display: 'inline-block', marginTop: '10px', padding: '4px 12px', border: `2px solid ${borderColor}`, borderRadius: '20px', fontSize: '1rem', color: borderColor, fontWeight: 'bold' }}>
                                        CÓDIGO: {character.qr_code}
                                    </span>

                                    <div style={{
                                        marginTop: '15px',
                                        padding: '10px',
                                        backgroundColor: isWolf ? 'rgba(139,0,0,0.2)' : 'rgba(139,69,19,0.1)',
                                        borderRadius: '5px',
                                        color: isWolf ? '#ff4c4c' : '#8b4513',
                                        fontWeight: 'bold',
                                        fontSize: '1.2rem',
                                        border: `1px dashed ${borderColor}`
                                    }}>
                                        {isWolf ? '🐺 ASESINO INFILTRADO 🐺' : (isPista ? '🔍 PISTA ENCONTRADA 🔍' : '🧑‍🌾 INOCENTE 🧑‍🌾')}
                                    </div>
                                </div>

                                {character.img && (
                                    <div style={{
                                        padding: '12px',
                                        marginBottom: '30px',
                                        backgroundColor: isWolf ? '#111' : '#fff',
                                        border: `1px solid ${isWolf ? '#333' : '#ddd'}`,
                                        boxShadow: '3px 3px 8px rgba(0,0,0,0.15)',
                                        transform: 'rotate(-1.5deg)'
                                    }}>
                                        <img
                                            src={character.img.startsWith('http') || character.img.startsWith('data:') ? character.img : `data:image/jpeg;base64,${character.img}`}
                                            alt="Character"
                                            style={{ width: '100%', display: 'block', filter: isWolf ? 'contrast(1.2)' : 'sepia(40%) contrast(1.1)' }}
                                        />
                                    </div>
                                )}

                                <div
                                    className="journal-content"
                                    style={{
                                        lineHeight: '1.8',
                                        fontSize: '1.3rem',
                                        textAlign: 'justify',
                                        color: textColor
                                    }}
                                    dangerouslySetInnerHTML={{ __html: character.descripcio || "" }}
                                />
                            </div>
                        </>
                    ) : (
                        <div style={{ color: '#b71c1c', textAlign: 'center', border: '4px dashed #b71c1c', padding: '30px', backgroundColor: '#ffebee' }}>
                            <h2 style={{ margin: 0, fontSize: '2rem' }}>ERROR DE LECTURA</h2>
                            <p style={{ margin: '15px 0 0 0', fontWeight: 'bold', fontSize: '1.3rem' }}>{error}</p>
                        </div>
                    )}
                </div>
            )}

            {!scanning && (
                <div style={{ width: '100%', maxWidth: '800px', display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '40px' }}>
                    {character?.qr_code?.startsWith('PER') && !isDead && (
                        <button
                            onClick={() => {
                                localStorage.setItem('castronegro_my_qr', character.qr_code);
                                navigate('/beiricastro/votos');
                            }}
                            style={{
                                background: '#8b0000',
                                color: '#fff',
                                border: 'none',
                                padding: '20px',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                                display: 'block',
                                width: '100%',
                                fontFamily: 'inherit',
                                fontWeight: 'bold',
                                borderRadius: '8px',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                                transition: 'background 0.2s, transform 0.1s',
                                position: 'relative',
                                zIndex: 20
                            }}
                            onMouseOver={(e) => { e.currentTarget.style.background = '#ff4c4c'; }}
                            onMouseOut={(e) => { e.currentTarget.style.background = '#8b0000'; }}
                            onTouchStart={(e) => { e.currentTarget.style.transform = 'scale(0.98)'; }}
                            onTouchEnd={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                        >
                            IR A LA ASAMBLEA (VOTAR)
                        </button>
                    )}
                </div>
            )}

            <style>{`
                @keyframes blink { 50% { opacity: 0.5; } }
                .blink { animation: blink 1.5s infinite; }
                .journal-content table { width: 100%; border-collapse: collapse; margin-bottom: 1em; }
                .journal-content th, .journal-content td { border: 1px solid ${borderColor}; padding: 8px; }
                .journal-content blockquote { border-left: 4px solid ${borderColor}; margin: 1em 0; padding-left: 1em; font-style: italic; color: ${isWolf ? '#aaa' : '#555'}; }
            `}</style>
        </div>
    );
};

export default CastronegroCharacters;
